import type { SidebarItem } from "@/lib/sidebar-items";

/**
 * Куда ведёт строка боковой панели.
 *
 * Страницы — и документы, и дашборды — открываются по своему адресу
 * /page/<id>: его рисует новая версия. Таблицы-виды пока живут на /view/<id> в
 * прежней оболочке — до тех пор, пока их перенос в страницы-документы не
 * закончен.
 *
 * Отдельным модулем — чтобы проверить тестом: ошибка здесь тихая, никакой
 * поломки не видно, просто ссылка уводит не туда.
 */
export function sidebarItemHref(item: Pick<SidebarItem, "kind" | "targetId">, legacyViewId?: string | null): string {
  if (item.kind === "table") return `/view/${item.targetId}`;
  if (legacyViewId) return `/view/${encodeURIComponent(legacyViewId)}`;
  return `/page/${encodeURIComponent(item.targetId)}`;
}
